/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_LongShareService_ParticipantLongSharesListDto } from '../models/Wealthlane_AwardService_Dtos_LongShareService_ParticipantLongSharesListDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LongShareLegacyService {

    /**
     * @param awardType 
     * @param participantId 
     * @param isBrokerAccountCreated 
     * @param tadrsTransferStatusId 
     * @returns Wealthlane_AwardService_Dtos_LongShareService_ParticipantLongSharesListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppLongShareLegacyParticipantLongShares(
awardType?: string,
participantId?: string,
isBrokerAccountCreated?: boolean,
tadrsTransferStatusId?: number,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_LongShareService_ParticipantLongSharesListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/long-share-legacy/participant-long-shares',
            query: {
                'awardType': awardType,
                'participantId': participantId,
                'isBrokerAccountCreated': isBrokerAccountCreated,
                'tadrsTransferStatusId': tadrsTransferStatusId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
